import { IGenerationOption, Transpose } from '@lcp/transpose';
import { TransposeUI } from './transposeUI';
import { TransposeConfig } from './models/elementConfig';

export default () => {
  const app = document.querySelector<HTMLElement>('#transposeApp');
  const clientId = app?.dataset.clientId as string;
  const fileId = app?.dataset.fileId as string;
  const apiKey = app?.dataset.apiKey as string;
  const base64String = app?.dataset.defaultOptions || '';
  const jsonString = atob(base64String);

  // Parse the JSON string into an array of IGenerationOption objects
  const defaultOptions: IGenerationOption[] = JSON.parse(jsonString);

  // Initialize Transpose
  Transpose.initialise({
    clientId,
    apiKey,
  }).then(async (transpose) => {
    // call transpose API and get generation options
    const fileOptions: IGenerationOption[] = await transpose.fetchFileOptions(fileId);

    // optional configuration - elements object can be omitted
    const config: TransposeConfig = {
      options: fileOptions,
      transpose,
      fileId,
      defaultOptions
      /* defaults
      elements: {
        contentSelect: {         
          parent: undefined
        },
        languageSelect: {
          parent: undefined
        }
      }*/
    };

    // show the button and allow modal to be opened
    const button = document.querySelector<HTMLElement>('#openModal');
    button?.classList.remove('ts-button--hidden');
    document.querySelector<HTMLElement>('#openModal')?.addEventListener('click', () => {
      document.querySelector<HTMLElement>('.ts-modal')?.classList.add('ts-modal--visible');
      document.querySelector<HTMLInputElement>('#tsTypeToggle')!.checked = false;
      // create the UI
      const ui = TransposeUI.create(config);
      ui.initialize();
    });

  }).catch((error) => {
    console.warn(error.message);
  });
};
